import script from "./ComingSoonView.vue?vue&type=script&setup=true&lang=js"
export * from "./ComingSoonView.vue?vue&type=script&setup=true&lang=js"

import "./ComingSoonView.vue?vue&type=style&index=0&id=00335397&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00335397"]])

export default __exports__